var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "Thông tin điểm danh: " +
              (_vm.attendanceData ? _vm.attendanceData.nameStudent : ""),
            visible: _vm.dialogVisible,
            width: "800px",
            "before-close": _vm.closeDialogByButton,
            "close-on-click-modal": false,
            top: "6vh",
            "custom-class": "premium-attendance-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.attendanceData
            ? _c(
                "el-form",
                {
                  ref: "attendanceKid",
                  staticClass: "timeline-form",
                  attrs: {
                    "label-width": "120px",
                    model: _vm.attendanceData,
                    "label-position": "top",
                  },
                },
                [
                  _c("div", { staticClass: "timeline-container" }, [
                    _c("div", { staticClass: "timeline-line" }),
                    _c("div", { staticClass: "timeline-item checkin" }, [
                      _c(
                        "div",
                        { staticClass: "timeline-badge checkin-badge" },
                        [_c("i", { staticClass: "el-icon-sunrise" })]
                      ),
                      _c("div", { staticClass: "timeline-uploader-wrapper" }, [
                        _c("div", { staticClass: "uploader-title" }, [
                          _vm._v("ẢNH ĐẾN"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "uploader-and-clock" },
                          [
                            _c("image-uploader", {
                              attrs: {
                                preview: _vm.attendanceData.urlPictureArrive,
                                placeholder: "Tải ảnh đến",
                                updateAttendance: _vm.isDisabledUploadImage(),
                              },
                              model: {
                                value: _vm.imageArriveUpload,
                                callback: function ($$v) {
                                  _vm.imageArriveUpload = $$v
                                },
                                expression: "imageArriveUpload",
                              },
                            }),
                            _vm.attendanceData.arriveTime
                              ? _c(
                                  "div",
                                  { staticClass: "visual-clock-container" },
                                  [
                                    _c("div", { staticClass: "analog-clock" }, [
                                      _c("div", { staticClass: "clock-face" }, [
                                        _c("div", { staticClass: "clock-dot" }),
                                        _c("div", {
                                          staticClass: "clock-hand hour",
                                          style: {
                                            transform:
                                              _vm.getClockHandsRotation(
                                                _vm.attendanceData.arriveTime
                                              ).hour,
                                          },
                                        }),
                                        _c("div", {
                                          staticClass: "clock-hand minute",
                                          style: {
                                            transform:
                                              _vm.getClockHandsRotation(
                                                _vm.attendanceData.arriveTime
                                              ).minute,
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "digital-clock" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time",
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatTime")(
                                                _vm.attendanceData.arriveTime
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "no-time-badge" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(" Chưa check-in\n              "),
                                ]),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "timeline-item checkout" }, [
                      _c(
                        "div",
                        { staticClass: "timeline-badge checkout-badge" },
                        [_c("i", { staticClass: "el-icon-sunset" })]
                      ),
                      _c("div", { staticClass: "timeline-uploader-wrapper" }, [
                        _c("div", { staticClass: "uploader-title" }, [
                          _vm._v("ẢNH VỀ"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "uploader-and-clock" },
                          [
                            _c("image-uploader", {
                              attrs: {
                                preview: _vm.attendanceData.urlPictureLeave,
                                placeholder: "Tải ảnh về",
                                updateAttendance: _vm.isDisabledUploadImage(),
                              },
                              model: {
                                value: _vm.imageLeaveUpload,
                                callback: function ($$v) {
                                  _vm.imageLeaveUpload = $$v
                                },
                                expression: "imageLeaveUpload",
                              },
                            }),
                            _vm.attendanceData.leaveTime
                              ? _c(
                                  "div",
                                  { staticClass: "visual-clock-container" },
                                  [
                                    _c("div", { staticClass: "analog-clock" }, [
                                      _c("div", { staticClass: "clock-face" }, [
                                        _c("div", { staticClass: "clock-dot" }),
                                        _c("div", {
                                          staticClass: "clock-hand hour",
                                          style: {
                                            transform:
                                              _vm.getClockHandsRotation(
                                                _vm.attendanceData.leaveTime
                                              ).hour,
                                          },
                                        }),
                                        _c("div", {
                                          staticClass: "clock-hand minute",
                                          style: {
                                            transform:
                                              _vm.getClockHandsRotation(
                                                _vm.attendanceData.leaveTime
                                              ).minute,
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "digital-clock" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time",
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatTime")(
                                                _vm.attendanceData.leaveTime
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "no-time-badge" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(" Chưa check-out\n              "),
                                ]),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "timeline-item note" }, [
                      _c("div", { staticClass: "timeline-badge note-badge" }, [
                        _c("i", { staticClass: "el-icon-edit-outline" }),
                      ]),
                      _c("div", { staticClass: "timeline-card note-card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _c("span", { staticClass: "card-title" }, [
                            _vm._v("GHI CHÚ CHUNG"),
                          ]),
                        ]),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            {
                              staticClass: "custom-attendance-status-container",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "note-input-section" },
                                [
                                  _c("el-input", {
                                    staticClass: "premium-textarea",
                                    attrs: {
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "Nhập nội dung ghi chú...",
                                      value: _vm.getAttendanceNote(),
                                    },
                                    on: {
                                      input: (val) => _vm.onChangeNote(val),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.attendanceData.createdBy ||
                    _vm.attendanceData.createdDate
                      ? _c("div", { staticClass: "timeline-item info-meta" }, [
                          _c(
                            "div",
                            { staticClass: "timeline-badge info-badge" },
                            [_c("i", { staticClass: "el-icon-user-solid" })]
                          ),
                          _c(
                            "div",
                            { staticClass: "timeline-card info-card" },
                            [
                              _c(
                                "div",
                                { staticClass: "card-body meta-body" },
                                [
                                  _vm.attendanceData.createdBy
                                    ? _c("div", { staticClass: "meta-row" }, [
                                        _c("i", {
                                          staticClass: "el-icon-user icon-blue",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "meta-label" },
                                          [_vm._v("Người tạo:")]
                                        ),
                                        _c(
                                          "strong",
                                          { staticClass: "meta-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceData.createdBy
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.attendanceData.createdDate
                                    ? _c("div", { staticClass: "meta-row" }, [
                                        _c("i", {
                                          staticClass: "el-icon-time icon-blue",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "meta-label" },
                                          [_vm._v("Thời gian tạo:")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "meta-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  _vm.attendanceData.createdDate
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "edit-history-section" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "history-toggle",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.fetchEditHistoryAttendance()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "toggle-title" }, [
                            _c("i", { staticClass: "el-icon-notebook-2" }),
                            _vm._v(" Lịch sử chỉnh sửa điểm danh\n          "),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "toggle-btn",
                              attrs: { size: "mini", type: "text" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.editHistory == null
                                      ? "Hiện lịch sử"
                                      : "Ẩn lịch sử"
                                  ) +
                                  "\n            "
                              ),
                              _c("i", {
                                class:
                                  _vm.editHistory == null
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                        _vm.editHistory != null
                          ? _c(
                              "div",
                              { staticClass: "history-timeline-container" },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.isLoadingHistory,
                                        expression: "isLoadingHistory",
                                      },
                                    ],
                                    staticClass:
                                      "history-timeline-loading-wrapper",
                                  },
                                  [
                                    _vm.editHistory.length === 0
                                      ? _c(
                                          "div",
                                          { staticClass: "no-history-text" },
                                          [
                                            _vm._v(
                                              "\n                Chưa có lịch sử chỉnh sửa nào.\n              "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "history-timeline" },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "history-timeline-line",
                                            }),
                                            _vm._l(
                                              _vm.editHistory,
                                              function (row, rIdx) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: rIdx,
                                                    staticClass:
                                                      "history-timeline-item",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "history-timeline-badge",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit",
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "history-timeline-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "history-panel-header",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "editor-name",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-user",
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      row.createdBy
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "editor-time",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-time",
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatDateTime"
                                                                      )(
                                                                        row.createdDate
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "history-panel-body",
                                                          },
                                                          _vm._l(
                                                            row.contentChanges,
                                                            function (
                                                              change,
                                                              cIdx
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: cIdx,
                                                                  staticClass:
                                                                    "change-detail-row",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-caret-right",
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        change
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _c("div", { staticClass: "dialog-loading-container" }, [
                _c("i", { staticClass: "el-icon-loading spinner-icon" }),
                _c("span", [_vm._v("Đang tải thông tin điểm danh...")]),
              ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "footer-btn save-btn",
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.isLoadingSave,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveAttendance()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _vm._v(" Lưu thay đổi\n      "),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "footer-btn close-btn",
                  attrs: { type: "info", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }